import React from 'react';
import TldvConfigTab from './TldvConfigTab';
import RecallConfigTab from './RecallConfigTab';
import GoogleMeetConfigTab from './GoogleMeetConfigTab';

/**
 * "Meetings & Integrations" tab — groups the per-org meeting-provider configs
 * (tl;dv, Recall.ai, Google Meet) into a single tab with stacked
 * sub-sections.
 */
const MeetingsIntegrationsTab = ({ orgId, org }) => (
  <div className="space-y-6">
    <GoogleMeetConfigTab orgId={orgId} org={org} />
    <TldvConfigTab orgId={orgId} org={org} />
    <RecallConfigTab orgId={orgId} org={org} />
  </div>
);

export default MeetingsIntegrationsTab;
